"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplicitEnumValue = exports.ExplicitEnumVariantDefinition = exports.ExplicitEnumType = void 0;
const utils_1 = require("../../utils");
const types_1 = require("./types");
class ExplicitEnumType extends types_1.CustomType {
    constructor(name, variants) {
        super(name);
        this.variants = [];
        this.variants = variants;
    }
    getClassName() {
        return ExplicitEnumType.ClassName;
    }
    static fromJSON(json) {
        const variants = json.variants.map((variant) => ExplicitEnumVariantDefinition.fromJSON(variant));
        return new ExplicitEnumType(json.name, variants);
    }
    getVariantByName(name) {
        let result = this.variants.find((e) => e.name == name);
        utils_1.guardValueIsSet(`variant by name (${name})`, result);
        return result;
    }
}
exports.ExplicitEnumType = ExplicitEnumType;
ExplicitEnumType.ClassName = "ExplicitEnumType";
class ExplicitEnumVariantDefinition {
    constructor(name) {
        this.name = name;
    }
    static fromJSON(json) {
        return new ExplicitEnumVariantDefinition(json.name);
    }
}
exports.ExplicitEnumVariantDefinition = ExplicitEnumVariantDefinition;
class ExplicitEnumValue extends types_1.TypedValue {
    constructor(type, variant) {
        super(type);
        this.name = variant.name;
    }
    getClassName() {
        return ExplicitEnumValue.ClassName;
    }
    /**
     * Utility (named constructor) to create a simple (i.e. without fields) enum value.
     */
    static fromName(type, name) {
        let variant = type.getVariantByName(name);
        return new ExplicitEnumValue(type, variant);
    }
    equals(other) {
        if (!this.getType().equals(other.getType())) {
            return false;
        }
        return this.name == other.name;
    }
    valueOf() {
        return { name: this.name };
    }
}
exports.ExplicitEnumValue = ExplicitEnumValue;
ExplicitEnumValue.ClassName = "ExplicitEnumValue";
//# sourceMappingURL=explicit-enum.js.map